module.exports = __webpack_public_path__ + "static/img/title.7dca5c77.png";